(() => {
  'use strict';
  const PRODUCT_ID = '7289473531968';
  const ROW = '[data-idw-quote-id][data-idw-quote-product="' + PRODUCT_ID + '"]';
  const UNSAFE = '.gpo-editCart, quantity-input, cart-remove-button';
  const CART = 'cart-items, cart-drawer, #main-cart-footer, cart-notification';
  let busy = false;

  function quoteLines(cart, quoteId) {
    if (!cart || !Array.isArray(cart.items)) throw new Error('cart-response');
    return cart.items.filter(item => String(item.product_id) === PRODUCT_ID && item.properties?._quote_id === quoteId);
  }

  async function requestCart(path, options = {}) {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + path, { credentials: 'same-origin', cache: 'no-store', ...options, signal: AbortSignal.timeout(20000) });
    if (!response.ok) throw new Error('cart-request');
    const cart = await response.json();
    if (!cart || !Array.isArray(cart.items)) throw new Error('cart-response');
    return cart;
  }

  function quoteRemovalBlocked(cart) {
    if (document.documentElement.hasAttribute('data-idw-quote-guard')) return true;
    if (!cart) return false;
    try {
      const pending = window.IDWQuotePendingGuard?.journal?.findCart(cart.token);
      return !Array.isArray(pending) || pending.length > 0;
    } catch {
      return true;
    }
  }

  async function removeQuote(quoteId) {
    if (!quoteId) throw new Error('quote-id');
    if (quoteRemovalBlocked()) throw new Error('quote-pending');
    const before = await requestCart('cart.js');
    const lines = quoteLines(before, quoteId);
    if (!lines.length) return;
    const updates = {};
    lines.forEach(item => {
      if (typeof item.key !== 'string' || !item.key.includes(':')) throw new Error('line-key');
      updates[item.key] = 0;
    });
    if (quoteRemovalBlocked(before)) throw new Error('quote-pending');
    try {
      await requestCart('cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
    } catch (error) {
      const current = await requestCart('cart.js');
      if (quoteLines(current, quoteId).length) throw error;
      return;
    }
    const after = await requestCart('cart.js');
    if (quoteLines(after, quoteId).length) throw new Error('quote-still-present');
  }

  document.addEventListener('click', async event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    if (busy && target.closest(CART)) {
      event.preventDefault(); event.stopImmediatePropagation(); return;
    }
    const row = target.closest(ROW);
    if (!row) return;
    if (target.closest(UNSAFE)) {
      event.preventDefault(); event.stopImmediatePropagation(); return;
    }
    const box = target.closest('[data-quote-actions]');
    if (!box) return;
    if (target.closest('[data-quote-remove-cancel]')) {
      box.querySelector('details').open = false;
      box.querySelector('summary').focus();
      return;
    }
    const button = target.closest('[data-quote-remove-confirm]');
    if (!button) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (quoteRemovalBlocked() || document.querySelector('.cart__items--disabled')) {
      box.querySelector('[data-quote-remove-status]').textContent = box.dataset.wait;
      return;
    }
    busy = true;
    button.disabled = true;
    document.documentElement.setAttribute('data-idw-quote-removing', '');
    const status = box.querySelector('[data-quote-remove-status]');
    status.textContent = box.dataset.busy;
    const locked = Array.from(document.querySelectorAll(CART)).map(node => ({ node, inert: node.inert }));
    locked.forEach(({ node }) => { node.inert = true; });
    try {
      await removeQuote(row.dataset.idwQuoteId);
      window.location.reload();
    } catch (error) {
      status.textContent = error?.message === 'quote-pending' ? box.dataset.wait : box.dataset.error;
      locked.forEach(({ node, inert }) => { node.inert = inert; });
      document.documentElement.removeAttribute('data-idw-quote-removing');
      button.disabled = false;
      busy = false;
      button.focus();
    }
  }, true);

  ['change', 'submit'].forEach(type => document.addEventListener(type, event => {
    const target = event.target instanceof Element ? event.target : null;
    if (target && ((busy && target.closest(CART)) || (type === 'change' && target.closest(ROW) && target.matches('[name="updates[]"]')))) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true));
})();
